import { render, staticRenderFns } from "./InjuryCases.vue?vue&type=template&id=663907b4&scoped=true"
import script from "./InjuryCases.vue?vue&type=script&lang=js"
export * from "./InjuryCases.vue?vue&type=script&lang=js"
import style0 from "./InjuryCases.vue?vue&type=style&index=0&id=663907b4&prod&lang=scss&scoped=true"
import style1 from "./InjuryCases.vue?vue&type=style&index=1&id=663907b4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "663907b4",
  null
  
)

export default component.exports